import { FC, useCallback, useEffect, useRef } from 'react';
import ReCaptchaV2, { ReCAPTCHA } from 'react-google-recaptcha';
import { useGoogleReCaptcha as useReCaptchaV3 } from 'react-google-recaptcha-v3';
import { useReCaptchaV2 } from './google-re-captcha-v2-provider.component';

interface Props {
	showCheckbox: boolean;
	onVerifyV2(token: string | null): void;
	onVerifyV3(token: string): void;
}

export const ReCaptchaBackgroundVerifier: FC<Props> = props => {
	const { onVerifyV2, onVerifyV3, showCheckbox } = props;

	// V3 invisible recaptcha
	const { executeRecaptcha } = useReCaptchaV3();
	// V2 checkbox recaptcha - display when V3 fails (showCheckbox flag)
	const { reCaptchaV2SiteKey } = useReCaptchaV2();

	const onChange = useCallback((value: string | null) => onVerifyV2(value), [onVerifyV2]);

	const handleReCaptchaVerify = useCallback(async () => {
		if (!executeRecaptcha) {
			return;
		}
		const token = await executeRecaptcha('signUpAction');

		onVerifyV3(token);
	}, [executeRecaptcha, onVerifyV3]);

	useEffect(() => {
		// verify on mount
		handleReCaptchaVerify();
	}, [handleReCaptchaVerify]);

	if (!reCaptchaV2SiteKey) {
		return null;
	}

	return (
		<ReCaptchaV2
			style={{
				display: showCheckbox ? 'block' : 'none',
				marginBottom: '16px',
			}}
			size='normal'
			sitekey={reCaptchaV2SiteKey}
			onChange={onChange}
		/>
	);
};

export default ReCaptchaBackgroundVerifier;
